import React from 'react';

const SCHEDULE = [
  { vaccine: 'BCG', doses: ['At birth'] },
  { vaccine: 'OPV', doses: ['Birth', '6w', '10w', '14w'] },
  { vaccine: 'Pentavalent', doses: ['6w', '10w', '14w'] },
  { vaccine: 'MMR', doses: ['9–12m', '16–24m'] },
  { vaccine: 'Hepatitis B', doses: ['Birth', '6w', '10w', '14w'] },
  { vaccine: 'Typhoid', doses: ['≥2y booster'] },
  { vaccine: 'Influenza', doses: ['Annual'] },
  { vaccine: 'COVID-19', doses: ['Primary', 'Booster'] },
];

/** IAP-style vaccination chart */
export default function VaccinationChart({ records = [], onChange, readOnly, patientAge }) {
  const get = (vaccine, dose) => records.find((r) => r.vaccine === vaccine && r.dose === dose) || {};

  const toggle = (vaccine, dose, field, val) => {
    if (readOnly || !onChange) return;
    const rest = records.filter((r) => !(r.vaccine === vaccine && r.dose === dose));
    const existing = get(vaccine, dose);
    onChange([...rest, { ...existing, vaccine, dose, [field]: val }]);
  };

  return (
    <div className="card vaccination-chart" style={{ borderLeft: '4px solid #06b6d4' }}>
      <h4 style={{ margin: '0 0 8px', color: '#0891b2' }}>Vaccination chart</h4>
      {patientAge && <p className="hint" style={{ fontSize: 11 }}>Patient age: {patientAge}</p>}
      <div style={{ overflowX: 'auto' }}>
        <table className="data-table" style={{ fontSize: 12 }}>
          <thead>
            <tr><th>Vaccine</th><th>Dose</th><th>Date given</th><th>Batch</th><th>Due next</th></tr>
          </thead>
          <tbody>
            {SCHEDULE.flatMap((row) => row.doses.map((dose) => {
              const rec = get(row.vaccine, dose);
              return (
                <tr key={`${row.vaccine}-${dose}`}>
                  <td>{row.vaccine}</td>
                  <td>{dose}</td>
                  <td><input type="date" className="input input-sm" value={rec.givenDate || ''} disabled={readOnly} onChange={(e) => toggle(row.vaccine, dose, 'givenDate', e.target.value)} /></td>
                  <td><input className="input input-sm" value={rec.batch || ''} disabled={readOnly} onChange={(e) => toggle(row.vaccine, dose, 'batch', e.target.value)} /></td>
                  <td><input type="date" className="input input-sm" value={rec.dueDate || ''} disabled={readOnly} onChange={(e) => toggle(row.vaccine, dose, 'dueDate', e.target.value)} /></td>
                </tr>
              );
            }))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
